import * as React from "react";

export const Checkbox = ({
    inputKey,
    checked,
    clickable,
    color,
    label,
    onChange,
    className
}: {
    inputKey: string;
    checked: boolean;
    clickable: boolean;
    color: string;
    label: string;
    onChange: () => void;
    className?: string;
}) => {
    return (
        <label
            htmlFor={inputKey}
            className={`${className} ${color ? "flex" : "inline"} items-center`}
        >
            {clickable && (
                <input
                    type="checkbox"
                    className={`relative mr-2.5 h-[16px] w-[16px] appearance-none rounded-sm border-[1px] border-zinc-300 bg-white bg-no-repeat
            checked:border-transparent checked:bg-[url('/ico_check.svg')] checked:bg-cover checked:bg-center`}
                    id={inputKey}
                    name={inputKey}
                    checked={checked || false}
                    style={
                        checked
                            ? {
                                  backgroundColor: color || "#888888"
                              }
                            : {}
                    }
                    onChange={onChange}
                />
            )}
            {color && (
                <div
                    className="mr-[6px] inline-block h-[10px] w-[10px] rounded-full"
                    style={{
                        backgroundColor: color
                    }}
                />
            )}
            <span className="text-[14px] font-normal tracking-wide">
                {label}
            </span>
        </label>
    );
};
